<template>
  <div class="product_type">
    <div class="row __centerblock">
      <div class="col text-center">
        <h3 class="text-center __titleGlobal">Choose Your Product Type</h3>
          <button
            class="__block __blocksize"
            type="button"
            name="button"
            @click="chooseProductType('General Cargo')"
            v-bind:class="{ active: isGeneral }"
          >
            <div class="row m-0 justify-content-center">
              <img class="__img" src = "@/assets/image/instantprice/shirt.png">
              <p class="__title">General Cargo</p>
            </div>
          </button>
          <button
            class="__block __blocksize"
            type="button"
            name="button"
            @click="chooseProductType('Special Cargo')"
            v-bind:class="{ active: isSpecial }"
          >
            <div class="row m-0 justify-content-center">
              <img class="__img" src = "@/assets/image/instantprice/diet.png">
              <p class="__title">Special Cargo</p>
            </div>
          </button>
          <button
            class="__block __blocksize"
            type="button"
            name="button"
            @click="chooseProductType('Dangerous Goods')"
            v-bind:class="{ active: isDangerous }"
          >
            <div class="row m-0 justify-content-center">
              <img class="__img" src = "@/assets/image/instantprice/caution.png">
              <p class="__title">Dangerous Goods</p>
            </div>
          </button>
          <div class="col __inputfield4">
            <div class="row justify-content-between">
              <div>
                <div class="__customdropdown4">
                  <p>What kind of goods you shipped?</p>
                  <b-input-group>
                    <b-dropdown no-flip>
                      <template slot="button-content">
                        <p class="m-0" :class="form.productType ? 'item__selected' : ''">{{ kindOfGoods }}</p>
                      </template>
                      <div v-if="isGoods === 'General Cargo'">
                        <b-dropdown-item @click="selectedOption(goodsType.text)" v-for="(goodsType,i) in goodsGeneral" :key="i" >
                          <span>{{ goodsType.text }}</span>
                        </b-dropdown-item>
                      </div>
                      <div v-if="isGoods === 'Special Cargo'">
                        <b-dropdown-item @click="selectedOption(goodsType.text)" v-for="(goodsType,i) in goodsSpecial" :key="i">
                          <span>{{ goodsType.text }}</span>
                        </b-dropdown-item>
                      </div>
                      <div v-if="isGoods === 'Dangerous Goods'">
                        <b-dropdown-item @click="selectedOption(goodsType.text)" v-for="(goodsType,i) in goodsDangerous" :key="i">
                          <span>{{ goodsType.text }}</span>
                        </b-dropdown-item>
                      </div>
                    </b-dropdown>
                  </b-input-group>
                  <div v-if="showErrorProductType && error.productType" class="text-left input-group __input">
                    <small class="text-danger">Required</small>
                  </div>
                </div>
                <div class="__code">
                  <p>HS Code</p>
                  <b-input-group class="__input">
                    <b-form-input v-model="form.commoditiesHSCode" type="text" placeholder="Type Your HS Code" />
                  </b-input-group>
                  <div v-if="showErrorProductType && error.commoditiesHSCode" class="text-left input-group __input">
                    <small class="text-danger">Required</small>
                  </div>
                </div>
                <div class="__description">
                  <p>Product Description</p>
                    <b-form-textarea
                      id="textarea"
                      placeholder="Type Your Product Description"
                      rows="3"
                      max-rows="5"
                      class="__textarea"
                      v-model="form.commoditiesProduct"
                    />
                    <div v-if="showErrorProductType && error.commoditiesProduct" class="text-left input-group __input">
                      <small class="text-danger">Required</small>
                    </div>
                </div>
              </div>
              <div>
                <div class="__goods">
                  <p>Value of goods (IDR)</p>
                  <b-input-group class="__input">
                    <money class="__money" :class="form.goodsValue === 0 ? 'init_value' : ''" v-model="form.goodsValue" placeholder="0" :value="form.goodsValue" ></money>
                  </b-input-group>
                  <div v-if="showErrorProductType && error.goodsValue" class="text-left input-group __input">
                    <small class="text-danger">Required</small>
                  </div>
                </div>
                <div class="__goods">
                  <div class="row m-0 justify-content-between">
                    <p>PO Number</p>
                    <p style="font-size: 14px">*optional</p>
                  </div>
                  <b-input-group class="__input">
                    <b-form-input type="text" v-model="form.po_number" placeholder="0" />
                  </b-input-group>
                </div>
                <div class="__goods" v-if="form.commoditiesClass === 'DG'">
                  <p>UN Number</p>
                  <b-input-group class="__input">
                    <b-form-input type="text" v-model="form.un_number" placeholder="0" />
                  </b-input-group>
                  <div v-if="showErrorProductType && error.un_number" class="text-left input-group __input">
                    <small class="text-danger">Required</small>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="row">

            </div>
            <div class="row">

            </div> -->
          </div>  <!-- end __inputfield -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductType',
  props: {
    showErrorProductType: Boolean,
    checkErrorStat: String
  },
  data () {
    return {
      isGeneral: true,
      isSpecial: false,
      isDangerous: false,
      isGoods: 'General Cargo',
      kindOfGoods: 'What kind of goods you shipped ?',
      form: {
        typeObj: 'sub',
        productType: '',
        goodsValue: '',
        productDescription: '',
        commoditiesHSCode: '',
        commoditiesProduct: '',
        commoditiesClass: 'GENCO',
        po_number: '',
        un_number: ''
      },
      goodsGeneral: [
        { text: 'Food and Beverages' },
        { text: 'Machinery and Spareparts' },
        { text: 'Paper and Plastics' },
        { text: 'Textile and Garment' },
        { text: 'Perishable' },
        { text: 'Others' }
      ],
      goodsSpecial: [
        { text: 'Live Animal (AVI)' },
        { text: 'Human Remain (HUM)' },
        { text: 'Perishable Goods (PER)' },
        { text: 'Valuable Goods (VAL)' },
        { text: 'Smelling Goods' },
        { text: 'Live Human Organ (LHO)' },
        { text: 'Others' }
      ],
      goodsDangerous: [
        { text: 'Explosive Goods (REX)' },
        { text: 'Gasses (RPG)' },
        { text: 'Flammable Liquids (RFL)' },
        { text: 'Flammable Solids (RFS)' },
        { text: 'Oxidizer (ROX)' },
        { text: 'Toxic (RPB) & Infections Substances (RI)' },
        { text: 'Radiactive Material (RFN)' },
        { text: 'Corrosive (RCM)' },
        { text: 'Misscelanous Dangerous Goods (RMD)' },
        { text: 'Others' }
      ],
      error: {}
    }
  },
  computed: {
    productType () {
      return this.form.productType
    },
    goodsValue () {
      return this.form.goodsValue
    },
    productDescription () {
      return this.form.productDescription
    },
    commoditiesHSCode () {
      return this.form.commoditiesHSCode
    },
    commoditiesProduct () {
      return this.form.commoditiesProduct
    },
    commoditiesClass () {
      return this.form.commoditiesClass
    },
    un_number () {
      return this.form.un_number
    },
    po_number () {
      return this.form.po_number
    }
  },
  watch: {
    productType (value) {
      /* eslint-disable-next-line */
      this.error.productType = (value === '' || value === null) ? true : false
      this.$emit('IntantPriceData', this.form)
    },
    goodsValue (value) {
      /* eslint-disable-next-line */
      this.error.goodsValue = (value === '' || value === null) ? true : false
      this.$emit('IntantPriceData', this.form)
    },
    commoditiesHSCode (value) {
      /* eslint-disable-next-line */
      this.error.commoditiesHSCode = (value === '' || value === null) ? true : false
      this.$emit('IntantPriceData', this.form)
    },
    commoditiesProduct (value) {
      /* eslint-disable-next-line */
      this.error.commoditiesProduct = (value === '' || value === null) ? true : false
      this.$emit('IntantPriceData', this.form)
    },
    un_number (value) {
      /* eslint-disable-next-line */
      this.error.un_number = (value === '' || value === null) ? true : false
      this.$emit('IntantPriceData', this.form)
    },
    commoditiesClass (value) {
      /* eslint-disable-next-line */
      this.error.commoditiesClass = (value === '' || value === null) ? true : false
      this.$emit('IntantPriceData', this.form)
    },
    po_number (value) {
      this.$emit('IntantPriceData', this.form)
    },
    checkErrorStat (value) {
      this.checkError()
    }
  },
  methods: {
    checkError () {
      const data = this.form
      let error = this.error
      /* eslint-disable */
      error.goodsValue = (data.goodsValue === null || data.goodsValue === 0) ? true : false
      error.commoditiesHSCode = (data.commoditiesHSCode === '') ? true : false
      error.commoditiesProduct = (data.commoditiesProduct === '') ? true : false
      error.productType = (data.productType === '') ? true : false
      error.un_number = (data.un_number === '') ? true : false
    },
    chooseProductType (type) {
      this.isGeneral = type === 'General Cargo'
      this.isSpecial = type === 'Special Cargo'
      this.isDangerous = type === 'Dangerous Goods'
      if (type !== this.isGoods) {
        this.kindOfGoods = 'What kind of goods you shipped ?'
        this.form.productType = ''
        if (this.isGeneral) {
          this.form.commoditiesClass = 'GENCO'
          this.form.un_number = ''
          this.isGoods = type
        } else if (this.isSpecial) {
          this.form.commoditiesClass = 'SC'
          this.form.un_number = ''
          this.isGoods = type
        } else {
          this.form.commoditiesClass = 'DG'
          this.isGoods = type
        }
      }
      this.$emit('IntantPriceProductType', type)
      this.$emit('IntantPriceData', this.form)
    },
    selectedOption (params) {
      this.kindOfGoods = params
      this.form.productType = params
    }
  },
  mounted () {
    this.$emit('IntantPriceProductType', 'General Cargo')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/instantPrice/ProductType.vue